<template>
    <div>
        <div class="contents privacy"  :class="{ 'title-padding': !showTitle }">
            <div class="title" :class="{ 'title-show': !showTitle }">
                个人信息保护及隐私政策
            </div>
            <p class="title-o" :class="{ 'title-show': !showTitle }" >引言</p>
            <p class="title-info">天津辰星技术股份有限公司（以下简称“我们 ”）非常重视用户的隐私和个人信息保护。您在使用我们的产品或服务时，我们可能会收集和使用您的相关信息。我们希望通过《Movibot隐私政策》（以下简称“本隐私政策”）向您说明在您使用我们的产品或服务时，我们如何收集、使用、保存、共享、转让和披露这些信息，以及我们为您提供的访问、更新、删除和保护这些信息的方式</p>
            <p class="title-info">您在使用我们的产品或服务前，请务必仔细阅读并充分理解本政策。我们将在您首次注册、登录或使用我们的核心功能前，通过弹窗、勾选框等主动交互方式，向您明确提示本政策内容，并请您主动勾选“我已阅读并同意《Movibot隐私政策》” ，以取得您的明示同意。</p>
            <p class="title-info">本政策更新时，我们将通过站内信、弹窗提示或短信等显著方式通知您，并在您再次主动勾选同意后，方可继续使用更新后的服务。如您不同意更新后的政策，我们将停止为您提供服务，但您有权要求我们删除已收集的个人信息。</p>
            <p class="title-info">您在本政策更新后首次登录或使用服务时主动勾选同意，即表示您已阅读、理解并同意更新后的政策。</p>
            <p class="title-info">请您特别注意：本隐私政策适用于我们以网站、小程序以及随技术发展出现的新形态向您提供的各项产品和服务。如我们及关联公司的产品或服务中使用了Movibot的产品或服务（如使用Movibot账户登录）但未设独立隐私权政策的，则本隐私政策同样适用于该部分产品或服务。我们及关联公司及其向您提供的产品或服务单独设有隐私权政策的，则相应产品或服务则适用相应隐私权政策。</p>
            <p class="title-info">如对本隐私政策或相关事宜有任何问题，您可随时通过访问在线客服系统（<a href="https://www.movibot-art.com">https://www.movibot-art.com</a>）、发送邮件至<a href="mailto:public@atomrobot.com">public@atomrobot.com</a>或拨打我们的全国客服电话等多种方式与我们联系。</p>

            <p class="title-o-min title-o-min-b">
                本隐私政策将帮助您了解以下内容：
            </p>
            <p class="title-o-min">
                一、我们如何收集和使用您的个人信息
            </p>
            <p class="title-o-min">
                二、我们如何使用 Cookies 和同类技术
            </p>
            <p class="title-o-min">
                三、我们如何共享、转让您的个人信息
            </p>
            <p class="title-o-min">
                四、我们如何保护和保存您的个人信息
            </p>
            <p class="title-o-min">
                五、您如何管理个人信息
            </p>
            <p class="title-o-min">
                六、未成年人的个人信息保护
            </p>
            <p class="title-o-min">
                七、通知和修订
            </p>
            <p class="title-o-min">
                八、联系我们
            </p>

            <p class="title-o">一、我们如何收集和使用您的个人信息</p>
            <p class="title-info">
                个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。本隐私政策中涉及的个人信息包括：基本信息（包括个人姓名、住址、个人电话号码、电子邮箱）；网络身份标识信息（包括个人信息主体账号、IP地址以及与前述有关的密码、口令等）；个人上网记录（包括网页浏览记录、软件使用记录、点击记录等）；其他个人信息（包括个人位置信息、语音信息、图片、客服咨询记录等）。<br/>
                我们仅会出于以下目的，收集和使用您的个人信息：<br/>
                1. 您须授权我们收集和使用您个人信息的情形<br/>
                我们的产品或服务包括一些核心功能，这些功能包含实现线上浏览、注册、登录等所必须的功能及保障服务安全所必须的功能。我们可能会收集和使用下列与您有关的信息才能实现上述这些功能。如果您不提供相关信息，您将无法享受我们提供的产品或服务。这些收集场景包括：<br/>
                1.1 您提供的信息<br/>
                您在注册成为我们的用户/会员、向您提供产品或服务时，我们需要收集您的个人信息。我们仅收集为向您提供产品或服务所必要的信息，如果您不提供必要的个人信息，将会影响您使用我们的产品或服务。<br/>
                1.2 我们在您使用产品或服务过程中收集的您的信息<br/>
                您在使用我们的产品或服务时，系统可能通过Cookies自动采集相关信息，例如您的网页浏览器信息、缓存记录等；以及您在使用我们服务时，我们可能通过设备定位功能收集到有关您的位置信息。<br/>
                1.3 敏感个人信息的处理<br/>
                本隐私政策所涉及的个人信息中，以下信息属于《个人信息保护法》规定的敏感个人信息：个人位置信息（行踪轨迹）、语音信息（生物识别信息）、图片（可能包含人脸等生物识别信息） 。<br/>
                敏感个人信息一旦泄露或者非法使用，容易导致您的人格尊严受到侵害或者人身、财产安全受到危害。<br/>
                我们处理您的敏感个人信息时，将严格遵守以下规则：<br/>
                （1）仅在具有特定目的和充分必要性的情形下处理敏感个人信息；<br/>
                （2）在处理前，以显著方式向您告知处理敏感个人信息的必要性以及对您个人权益的影响；<br/>
                （3）取得您的单独同意，该同意独立于其他一般个人信息的同意，不以打包方式获取；<br/>
                （4）采取更为严格的数据安全保护措施，包括但不限于加密存储、访问权限严格控制、操作审计等；<br/>
                （5）在法律、行政法规规定的保存期限届满后，及时删除或匿名化处理敏感个人信息。<br/>
                2. 我们如何使用您的个人信息<br/>
                在符合相关法律法规规定的前提下，我们将出于以下目的，使用您的个人信息：<br/>
                2.1 实现产品和服务功能<br/>
                • 为您提供特定的产品和服务功能、为您提供相关的客服服务以及相关的辅助服务；<br/>
                • 对您进行回访，邀请您参与有关我们产品或服务的调查；<br/>
                • 向您发送关于我们与您的关系或产品/服务相关的重要信息、条款、条件、政策和/或其他行政信息的变更。<br/>
                2.2 实现商业目的<br/>
                • 用于数据分析，以增强、改善或改进我们的网站或产品和服务以及帮助我们开发新产品和服务；<br/>
                • 用于欺诈和安全的监控，例如探测和阻止网络攻击或窃取他人信息；<br/>
                2.3 您可选择提供个人信息的情形<br/>
                • 为使您的使用更便捷，部分扩展功能会收集和使用您的个人信息，如果您不提供这些个人信息，可能无法使用部分扩展功能；<br/>
                • 您可以向Movibot传输图片、视频等进行产品咨询并获得相关的配套服务，我们会使用您提交的图片、视频内容对产品或/及服务的内容、效果、反馈等进行识别。<br/>
                请您理解并同意，我们保证在不透露您的个人信息的前提下，对用户数据库进行分析并将用户数据库进行商业化利用。您所提供的所有个人信息，除非您删除或通过系统设置拒绝我们收集，否则将在您使用我们的产品或服务期间持续授权我们使用。<br/>
                如我们将您的个人信息用于本政策未载明的其他用途，或者将基于特定目的收集而来的个人信息用于其他目的时，我们将会事先征求您的同意。<br/>
                3. 例外情形<br/>
                您应充分知晓，在以下情形中，我们收集、使用您的个人信息无需征得您的授权同意：<br/>
                • 与国家安全、国防安全有关的；<br/>
                • 与公共安全、公共卫生、重大公共利益有关的；<br/>
                • 与犯罪侦查、起诉、审判或判决执行等有关的；<br/>
                • 出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；<br/>
                • 所收集的个人信息是您自行向社会公众公开的；<br/>
                • 从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道；<br/>
                • 根据您的要求签订和履行合同所必需的；<br/>
                • 用于维护所提供的产品与/或服务的安全稳定运行所必需的，例如发现、处置产品与/或服务的故障；<br/>
                • 为合法的新闻报道所必需的；<br/>
                • 学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；<br/>
                • 法律法规规定的其他情形
            </p>

            <p class="title-o">二、我们如何使用 Cookies 和同类技术</p>
            <p class="title-info">
                1. 为实现您联机体验的个性化需求，使您获得更轻松的访问体验。我们会在您的计算机或移动设备上发送一个或多个名为Cookies的小数据文件，指定给您的 Cookie 是唯一的，它只能被将Cookies发布给您的域中的Web服务器读取。我们向您发送Cookies是为了简化您重复登录的步骤、存储您的偏好或过往服务的数据，进而为您优化选择与互动、帮助判断您的登录状态以及账户或数据安全。<br/>
                2. 我们不会将 Cookies 用于本隐私政策所述目的之外的任何用途。您可根据自己的偏好管理或删除 Cookies。您可以清除计算机上保存的所有 Cookies，大部分网络浏览器会自动接受Cookies，但您通常可根据自己的需要来修改浏览器的设置以拒绝 Cookies；另外，您也可以清除软件内保存的所有Cookies。但如果您这么做，您可能需要在每一次访问Movibot时亲自更改用户设置，而且您之前所记录的相应信息也均会被删除，并且可能会对您所使用服务的安全性有一定影响。
            </p>

            <p class="title-o">三、我们如何共享、转让您的个人信息</p>
            <p class="title-info">
                1. 共享<br/>
                我们不会与任何公司、组织和个人共享您的个人信息，但除下列情况除外：<br/>
                1.1 事先获得您明确的同意或授权，或您要求我们通过电子邮件或其他方式与第三方共享您的个人信息；<br/>
                1.2 根据适用的法律法规规定，或按照政府主管部门的强制性要求进行提供；<br/>
                1.3 与我们的关联公司共享：我们可能会与我们的关联公司共享您的个人信息。但是我们只会共享必要的个人信息，且受本政策中所声明目的的约束。关联公司也将依据本政策采取同等的安全保障措施来保障您的个人信息安全；<br/>
                1.4 与业务合作伙伴共享：为了确保业务顺利开展以及更好地为您服务，在您同意的情况下，我们可能会向业务合作伙伴共享相关信息。我们仅出于合法、正当、必要、特定、明确的目的共享您的个人信息，且只会共享为提供产品或服务所必须的个人信息。我们的业务合作伙伴无权将您的相关个人信息用于任何其他用途。<br/>
                2. 转让<br/>
                我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：<br/>
                2.1 事先获得您的明确授权或同意，或您要求我们通过电子邮件或其他方式将您的个人信息转让给第三方；<br/>
                2.2 根据适用的法律法规规定，或按照政府主管部门的强制性要求进行提供；<br/>
                2.3 在涉及资产转让、收购、合并、重组或破产清算时，如涉及到个人信息转让，我们会向您告知有关情况，并要求新的持有您个人信息的公司、组织继续受本政策的约束。如变更个人信息使用目的，我们将要求该公司、组织重新取得您的授权同意。
            </p>

            <p class="title-o">四、我们如何保护和保存您的个人信息</p>
            <p class="title-info">
                我们非常重视个人信息安全，并采取一切合理可行的措施保护您的个人信息：<br/>
                1.建立数据安全管理措施<br/>
                （1）我们建立了全流程数据安全管理制度，明确各部门和岗位的数据安全责任；<br/>
                （2）我们定期对员工进行数据安全和隐私保护培训，提升员工的安全意识和合规意识；<br/>
                （3）我们制定了个人信息安全事件应急预案，在发生或可能发生个人信息泄露、篡改、丢失时，立即采取补救措施，并按照规定及时告知您并向有关主管部门报告。<br/>
                2. 互联网并非绝对安全的环境，且电子邮件、即时通讯、社交软件等与其他用户的交流方式无法确定是否完全加密，我们建议您使用此类工具时请使用复杂密码，并注意保护您的个人信息安全。在进行服务时，您不避免的要向对方或潜在的对方披露自己的个人信息，如联络方式或者地址等。请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。<br/>
                3. 目前，我们不存在向中华人民共和国境外传输您的个人信息的情形。<br/>
                如因业务发展需要，确需向境外提供个人信息的，我们将严格遵守《个人信息保护法》第三章的规定，至少具备以下条件之一后方可进行：<br/>
                （1）依照《个人信息保护法》第四十条的规定，通过国家网信部门组织的安全评估；<br/>
                （2）按照国家网信部门的规定，经专业机构进行个人信息保护认证；<br/>
                （3）按照国家网信部门制定的标准合同，与境外接收方订立合同，约定双方的权利和义务；<br/>
                （4）法律、行政法规或者国家网信部门规定的其他条件。<br/>
                在向境外提供个人信息前，我们将以显著方式向您告知境外接收方的名称、联系方式、处理目的、处理方式、个人信息的种类以及向境外提供个人信息可能带来的风险，并取得您的单独同意。<br/>
                您有权了解我们向境外提供个人信息的详细情况，如有疑问可通过本政策第八条所述联系方式与我们联系。<br/>
                4.我们仅在本政策所述目的所必需期间和法律及监管规定的时限内保存您的个人信息。超出上述保存期限后，我们将对您的个人信息进行删除或匿名化处理，但法律法规另有规定的除外。
            </p>

            <p class="title-o">五、您如何管理您的个人信息</p>
            <p class="title-info">
                我们非常重视您对个人信息的关注，并尽全力保护您对于您个人信息访问、更正、删除以及撤回同意的权利，以使您拥有充分的能力保障您的隐私和安全。您的权利包括：<br/>
                1. 除法律法规规定外，您有权随时访问和更正您的个人信息。<br/>
                2. 除法律法规规定外，您在我们的产品与/或服务页面中可以直接清除或删除的信息。<br/>
                3. 您可以在我们的产品中直接申请注销账户。您注销账户后，我们将停止为您提供产品与/或服务，并依据您的要求，除法律法规另有规定外，我们将删除您的个人信息或匿名化处理。<br/>
                4.撤销接受我们给您发送的相关邮件、信息，这些信息所涉及的内容包括且不限于以文字、图片、照片、音视频形式等表现的各类宣传信息、商业信息，该类信息的提供方式包括且不限于电子邮件、短信息等。如您不希望接收来自本网站的邮件，则可通过联系客服完成邮件与短信的退阅。<br/>
                5.基于您的同意而进行的个人信息处理活动，您有权随时撤回您的同意。<br/>
                您可通过在线客服（https://www.movibot-art.com）、发送邮件至public@atomrobot.com 或拨打客服电话等方式，提出撤回同意的请求。<br/>
                您撤回同意后，我们将停止处理相应的个人信息，并按照本政策第四条约定的保存期限规定，对已收集的个人信息进行删除或匿名化处理。您撤回同意不影响撤回前基于您的同意已进行的个人信息处理活动的效力。<br/>
                6.在以下情形中，您可以向我们提出删除个人信息的请求，我们将在核实您身份后十五个工作日内予以响应并删除：<br/>
                （1）处理目的已实现、无法实现或者为实现处理目的不再必要；<br/>
                （2）我们停止提供产品或者服务，或者保存期限已届满；<br/>
                （3）您撤回同意；<br/>
                （4）我们违反法律、行政法规或者违反约定处理您的个人信息；<br/>
                （5）法律、行政法规规定的其他情形。<br/>
                我们在上述情形发生后，将主动删除您的个人信息；如我们未主动删除的，您有权请求我们删除。<br/>
                法律、行政法规规定的保存期限未届满，或者删除个人信息从技术上难以实现的，我们将停止除存储和采取必要的安全保护措施之外的处理。<br/>
                为了保障安全，我们可能需要您提供书面请求，或提供您的身份证明文件，我们将在收到您反馈并验证您的身份后的15天内答复您的请求。对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际的请求，我们可能会予以拒绝。<br/>
                除上述内容外，在以下情形中按照法律法规要求，我们将无法响应您的请求：<br/>
                （1）与个人信息控制者履行法律法规规定的义务相关的；<br/>
                （2）与国家安全、国防安全有关的；<br/>
                （3）与公共安全、公共卫生、重大公共利益有关的；<br/>
                （4）与刑事侦查、起诉、审判或执行判决等有关的；<br/>
                （5）有充分证据表明您存在主观恶意或滥用权利的；<br/>
                （6）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；<br/>
                （7）响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；<br/>
                （8）涉及商业秘密的。
            </p>

            <p class="title-o">六、未成年人的个人信息保护</p>
            <p class="title-info">
                我们非常重视对未成年人个人信息的保护。若您是18周岁以下的未成年人，在使用我们的产品与/或服务前，应事先取得您监护人的同意。我们根据国家相关法律法规的规定保护未成年人的个人信息。<br/>
                若您是不满14周岁的儿童，在使用我们的产品与/或服务前，必须取得您的父母或其他监护人的明示同意。<br/>
                我们对于不满14周岁的儿童个人信息，采取以下特殊保护措施：<br/>
                （1）专门识别：我们在注册环节通过年龄验证等方式识别不满14周岁的儿童用户；<br/>
                （2）监护人同意机制：在收集儿童个人信息前，通过短信验证、邮件确认、人工核验等方式，取得其监护人的明示、单独同意；<br/>
                （3）最小必要原则：仅收集为提供具体服务所必需的儿童个人信息，不收集与其所使用服务无关的信息；<br/>
                （4）严格保密：对儿童个人信息采取比一般个人信息更为严格的安全保护措施；<br/>
                （5）监护人权利：儿童的监护人有权随时访问、更正、删除儿童的个人信息，或撤回同意。<br/>
                如果有事实证明未成年人并未取得监护人同意的情况下注册使用了我们的产品与/或服务，请监护人与我们联系协商，并设法尽快删除相关个人信息。
            </p>

            <p class="title-o">七、通知和修订</p>
            <p class="title-info">
                1. 为给您提供更好的服务以及随着我们业务发展的需要，本隐私政策也会随之更新。但未经您明确同意，我们不会削减您依据本隐私政策所应享有的权利。我们会通过在Movibot官方网站发出更新版本并在生效前通过网站公告或以其他适当方式提醒您相关内容的更新，也请您访问Movibot官方网站以便及时了解最新的隐私政策。<br/>
                2. 在本政策更新后，如您继续使用我们的网站、应用或服务，即表示您同意接受更新后的本政策约束。如无特殊说明，本政策以及本政策的更新版本自发布之日起生效。
            </p>

            <p class="title-o">八、如何联系我们</p>
            <p class="title-info">
                如您对本隐私政策或您个人信息的相关事宜有任何问题、意见或建议，请通过以下方式与我们联系：<br/>
                服务邮箱：<a href="mailto:public@atomrobot.com">public@atomrobot.com</a><br/>
                联系电话：400-653-7789<br/>
                联系地址：天津市滨海新区第八大街南海路156号通厂29号天津辰星技术股份有限公司
            </p>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        showTitle: {
            type: Boolean,
            default: true
        }
    }
}
</script>

<style scoped>
    p,div{
        font-family: 'Noto Sans SC';
        font-style: normal;
    }
    .privacy{
        padding-top: 50px;
        padding-bottom: 50px;
    }
    .title-padding{
        padding-top: 10px!important;
        width: 100%;
    }
    .privacy a{
        color: #007aff;
    }
    .title{
        font-weight: 400;
        font-size: 36px;
        line-height: 52px;
        color: #333333;
        text-align: center;
    }
    .title-show{
        display: none;
    }
    .title-o{
        font-size: 24px;
        line-height: 35px;
        color: #333333;
        margin-top: 20px;
    }
    .title-info{
        font-size: 18px;
        line-height: 25px;
        letter-spacing: 1px;
        color: #666666;
        margin-top: 20px;
    }
    .title-o-min{
        font-size: 16px;
        line-height: 25px;
        letter-spacing: 1px;
        color: #666666;
    }
    .title-o-min-b{
        color: #333;
        margin-top: 20px;
    }
</style>


// WEBPACK FOOTER //
// src/views/html/privacy.vue